import {
  MBD_ITEMS,
  MBD_TYPE,
} from '@shared/constants/meaningful-behaviour-data';

const buildDetailsMapAttributes = ({
  hotelId,
  item,
}: {
  hotelId: string;
  item?: string;
}) => {
  const { id, name } = MBD_ITEMS[MBD_TYPE.HOTEL_DETAILS_MAP];
  const trackingId = `${id}_${hotelId}`;

  return {
    id: item ? `${trackingId}_${item}` : trackingId,
    name: item ? `${name}_${item}` : `${name}_map`,
  };
};

export { buildDetailsMapAttributes };
